import { getMessageFactoryV2 } from "../getCaxaWebSocketV2.js";
const getChangedInfo = getMessageFactoryV2({
  code: "GET_CHANGED_INFO"
});
export { getChangedInfo };



// WEBPACK FOOTER //
// ./~/@oppein/op-utils/dist/es/external/caxa/directive/getChangedInfoV2.js